export class DisplayValueMap<Display extends string = '', Value extends string = ''> {
  display: Display;
  value: Value;

  constructor(display: Display, value: Value) {
    this.display = display;
    this.value = value;
  }
}

export class DisplayValueIconMap<Display extends string = '', Value extends string = ''> {
  display: Display;
  value: Value;
  icon: any;

  constructor(display: Display, value: Value, icon: any) {
    this.display = display;
    this.value = value;
    this.icon = icon;
  }
}

export interface Sorting<SortBy extends string, SortDir extends string> {
  sortBy: SortBy;
  sortDir: SortDir;
}

export type CastVariableType<CastInterface, VariableType> = {
  [K in keyof CastInterface]?: VariableType;
};
